import { buildQuery, containsQuery, OdataFilters, queryCollection, queryParams } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/cargoOwnerDictionary";
const listQuery = { orderBy: ["id desc"] as [string] };

const index = ({ preparedFilter, queryFilter, ...params }: OdataFilters) => {
    const qp = new URLSearchParams(queryFilter as URLSearchParams);
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery }).substr(1);
    const queryString = [qp.toString(), query].filter((item) => item.length).join("&");
    return request(`${resource}/get?&withDeleted=true&${queryString}`, { method: "GET" }, { countInHeaders: true });
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery });
    return request(
        `${resource}/getListExcel?${query}&withDeleted=true`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Контрагенты.xlsx"));
};

const getItems = (filter: {}) => {
    const query = buildQuery({ filter });
    return request(`${resource}/get${query}`, { method: "GET" });
};

const getPaymentStats = (id: number, days: number) => {
    const params: { id: number; days?: number } = { id };
    if (days) {
        params.days = days;
    }
    return request(`${resource}/getPaymentStats${queryParams(params)}`, { method: "GET" });
};

const list = (params: {}) => request(`${resource}/get${containsQuery(params)}`, { method: "GET" });

const namesList = (params: {}) => request(`${resource}/getNamesList${containsQuery(params)}`, { method: "GET" });

const selectList = (params: {}) => request(`${resource}/getListForSelect${containsQuery(params)}`, { method: "GET" });

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const syncLegalInformation = (params: {}) => alertRequest(`${resource}/SyncLegalInformation`, body(params));

const getItem = (params: { id: string }) => request(`${resource}/Get(${params.id})`, { method: "GET" });

const getDocuments = (id: string) => request(`${resource}/getDocuments/${id}`, { method: "GET" });

const applyDocuments = (params: {}) => alertRequest(`${resource}/applyDocuments`, body(params));

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const giveAccessToBids = (params: {}) => request(`${resource}/giveAccessToBids`, body(params));

const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));

const removeAccessToBids = (params: {}) => alertRequest(`${resource}/removeAccessToBids`, body(params));

const setContact = (params: {}) => alertRequest(`${resource}/setContact`, body(params));

export {
    index,
    apply,
    syncLegalInformation,
    getItem,
    delItem,
    list,
    selectList,
    getDocuments,
    applyDocuments,
    namesList,
    getItems,
    giveAccessToBids,
    restore,
    removeAccessToBids,
    getListExcel,
    getPaymentStats,
    setContact,
};
